<template>
  <sweet-modal ref="quizConfigModal" width="600px" :title="$t('ct-quiz-config')">
    <template v-if="!loading">
      <template v-if="success">
        <!-- Quizzes -->
        <div class="form-group mt-3 mb-5">
          <label> {{ $t('ct-select-quiz') }}</label>
          <select v-model="quiz_id" class="form-control">
            <option value="" disabled>{{ $t('ct-select-quiz') }}</option>
            <option v-for="(quiz, index) in quizzes"
                    :key="index"
                    :value="quiz.id"
                    v-text="quiz.title"
            />
          </select>
        </div>
      </template>

      <!-- None quizzes -->
      <div v-else>
        <h6>{{ $t('ct-quiz-have-create') }}<a :href="getUrlQuiz()" target="_blank">{{ $t('ct-quiz-app') }}</a></h6>
      </div>
    </template>
    <div class="text-center" v-else>
      <p>{{$t('ct-loading')}}</p>
    </div>

      <!-- Buttons modal -->
      <div class="footer-buttons">
        <a
          v-if="quizzes.length === 0"
          slot="button"
          class="btn btn-primary ml-0"
          :href="getUrlQuiz()"
          target="_blank"
        >{{ $t('ct-quiz-create') }}</a>
        <button
          slot="button"
          class="btn btn-outline-light ml-0"
          @click="$refs.quizConfigModal.close()"
        >{{ $t('ct-cancel') }}
        </button>
        <button
          v-if="success"
          slot="button"
          class="btn btn-success focus"
          @click="save"
        ><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
        </button>
      </div>
    </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';

import {getQuiz} from '../../../../js/services/integrations-internas/quiz';

export default {
  name: 'QuizQuizModal',
  components: {
    SweetModal
  },
  data() {
    return {
      options: {},
      quiz_id: '',
      showEvents: 0,
      quizzes: [],
      loading: true,
      success: false,
      callback: false
    };
  },
  methods: {
    save() {
      this.callback({ id: this.quiz_id});
      this.$refs.quizConfigModal.close();
    },

    getUrlQuiz() {
      const officeDomain = typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : 'https://office.builderall.com';

      return `${officeDomain}/br/office/quiz`;
    },

    getUserQuizzes() {
      const { email } = this.$store.state.user;

      getQuiz(email)
        .then(({data}) => {
          if (!data.length) {
            return;
          }

          this.success = true;
          this.quizzes = data;
        })
        .catch(error => console.error(error))
        .finally(() => this.loading = false);
    },
    init(config, callback = false) {
      this.options = config;
      this.quiz_id = "" + config.id;
      this.callback = callback;
    },
    open(modal = '') {
      this.$refs.quizConfigModal.open();
      this.getUserQuizzes();
    }
  }
};
</script>
<style lang="scss" scoped>
h6 {
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 26px;
  height: 120px;

  a {
    margin-left: 10px;
  }
}

.form-group {
  .row {
    margin: 0;
  }
}

.footer-buttons {
  display: block;
  text-align: right;

  .btn {
    &:first-child {
      float: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Quiz/ConfigModals.vue